import { create } from "zustand";
import { Device } from "../data/Device";

type DeviceGridStore = {
    selectedDevices: Device[];
    setSelectedDevices: (devices: Device[]) => void;
    clearSelectedDevices: () => void;
}

export const useDeviceGridStore = create<DeviceGridStore>((set) => ({
    selectedDevices: [],
    setSelectedDevices: (devices: Device[]) => set(() => ({ selectedDevices: devices })),
    clearSelectedDevices: () => set(() => ({ selectedDevices: [] })),
}));